import _ from 'lodash';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderAPI } from '../../apis/order-api';
import { CancelOrderModalBody } from '../../components/bill/cancel-order-modal-body';
import { useErrorHandler } from '../../hooks/use-error-handler';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { isExpired } from '../../utils/manager/session-manager';

function useCancelOrderModal() {
  const storage = useStorage();
  const { t } = useTranslation();
  const { spot } = storage;
  const { swal } = useSwal({ storage });
  const { loadOrderFromRemote, cancelOrderFromRemote } = useOrderAPI();
  const { handleErrorOnModal } = useErrorHandler();
  // const [loadErrorModal, showErrorModal] = useErrorModal();

  const orderRef = useRef();
  const errorRef = useRef();
  const retryRef = useRef();
  // const closedRef = useRef(false);

  async function prepare({ order }) {
    orderRef.current = null;
    errorRef.current = null;
    retryRef.current = false;

    try {
      const response = await loadOrderFromRemote(order.id);
      orderRef.current = response.data;
      errorRef.current = null;

      // loaded.order = response.data;
      // loaded.closed = isExpired(loaded.order.session);
    } catch (error) {
      // loaded.error = error;
      // await loadErrorModal();
      orderRef.current = null;
      errorRef.current = error;
    }

    // return loaded;
  }

  function isSessionExpired() {
    return isExpired(orderRef.current?.session);
  }

  async function show({ prepareOnPreConfirm }) {
    if (_.isError(errorRef.current)) {
      // return showErrorModal(loaded.error);
      return {
        error: errorRef.current,
      };
    }

    const buttonText = t(
      `cancel-order-modal.remove${spot?.prepaid ? '.prepaid' : ''}`
    );

    const result = await swal.fire({
      html: (
        <CancelOrderModalBody
          order={orderRef.current}
          closed={isSessionExpired()}
          spot={spot}
        />
      ),
      // timer: layoutDefaults.modalTimer,
      // didClose: resolve,
      showConfirmButton: true,
      showDenyButton: false,
      showCloseButton: !isSessionExpired(),
      allowOutsideClick: true,
      showCancelButton: !isSessionExpired(),
      showLoaderOnConfirm: true,
      preConfirm: () => preConfirm({ prepareOnPreConfirm }),
      confirmButtonText: isSessionExpired() ? t('back') : buttonText,
      cancelButtonText: t('back'),
    });

    result.error = errorRef.current;
    result.retry = retryRef.current;
    result.order = orderRef.current;

    // if (_.isError(result.value?.error)) {

    //   result.error = errorRef.current;
    //   // return showErrorModal(result.value?.error);
    // }

    // if (result.isConfirmed) {
    //   return { order: result.value?.order, retry: result.value?.retry };
    // }

    return result;
  }

  async function preConfirm({ prepareOnPreConfirm }) {
    // retryRef.current = false;
    // errorRef.current = null;

    // const result = { ...loaded };

    // if (loaded.closed === true) {
    //   return result;
    // }

    try {
      if (retryRef.current) {
        retryRef.current = false;
      } else {
        await cancelOrderFromRemote(orderRef.current?.id);
      }

      prepareOnPreConfirm?.call(this);
    } catch (error) {
      if (
        _.isArray(error.response?.data) &&
        error.response?.data?.find(() => true)?.code === 2
      ) {
        // result.retry = true;
        retryRef.current = true;
        // } else if (isSessionExpired() === false) {
        // result.error = error;
        // errorRef.current = error;
        // await loadErrorModal();
      } else {
        handleErrorOnModal(error);
        return false;
      }
    }

    return true;
    // return result;
  }

  return {
    prepareCancelOrderModal: prepare,
    showCancelOrderModal: show,
  };
}

export { useCancelOrderModal };
